module.exports = __webpack_public_path__ + "img/Lc.c7080f8a.png";